import style from './TableSelect.module.css'
import {ReactComponent as Filter} from '../../Assets/icons/FilterMap.svg'
import { closeAllSelect } from '../../Redux/Slices/Select/Select'
import { useDispatch, useSelector } from 'react-redux'
import { openOrClose } from '../../Redux/Slices/Select/Select'
import { useRef } from 'react'

export function TableFilterSelect({options = [], value ={id: null}, setValue, icon, isOpen, stateName, name, title='' }) {
    const dispatch = useDispatch()
    const ref = useRef(null)    

    const setIsOpen = () => {
        dispatch(openOrClose(stateName))
        isOpen && dispatch(closeAllSelect())
    }

    function handleClick (item) {
        if(value.some(elem => item[name.split('_')[0] + '_id'] === elem[name.split('_')[0] + '_id'])){
            setValue(value.filter(elem => item[name.split('_')[0] + '_id'] !== elem[name.split('_')[0] + '_id']))
        }else {
            setValue([...value, item])
        }
    }
       
    return <div className={`${style.table__filter__container} ${style.container_NoParrent} select`}  >
        <button title={title}  className={style.filter__icon} onClick={() => setIsOpen()}>{icon}</button>
        <div ref={ref} className={`${style.table__filter__list} ${isOpen ? style.active : ''} overlay`} style={{maxHeight: `calc(100vh - ${ref?.current?.getBoundingClientRect()?.top}px - 25px)`}} >
        <div className={style.modal__container}>
            <div className={`${style.map__list_item} ${value.length === 0 ? style.active_item : ''}`} onClick={() => {
                setValue([])
                // dispatch(closeAllSelect())
            }}>Не выбрано</div>
            {options.map((item, index) => {    
                return <div key={index} className={`${style.table__list_item} ${value.some(elem => elem[name.split('_')[0] + '_id'] === item[name.split('_')[0] + '_id']) ? style.active_item : ''}`} onClick={() => handleClick(item)}>{item[name]}</div>
            })}
            </div>        
        </div>
    </div>
}